import { render, staticRenderFns } from "./SetPrice.vue?vue&type=template&id=a9c6300a&scoped=true&"
import script from "./SetPrice.vue?vue&type=script&lang=js&"
export * from "./SetPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c6300a",
  null
  
)

export default component.exports